import { createFileRoute } from "@tanstack/react-router";
import RedirectPage from "@/pages/RedirectPage";

export const Route = createFileRoute("/zum-anbieter")({
  component: RedirectPage,
});
